import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapMicroContentSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapmicrocontent: {
      group: 'block',
      content: 'block+',
      fillIfContentDeleted: 'mcCentralContainer',
      linkBucket: 'micro_content',
      parseDOM: [{
        tag: 'MadCap\\:microContent'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:microContent'
    }
  } satisfies Record<string, NodeSpec>;
}
